import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { TableColumn } from '../../../../component-library/table/table-column';
import { TableConfig } from '../../../../component-library/table/table-config';
import { TableSelectionMode } from '../../../../component-library/table/table-selection-mode';
import { defaultRowsPerPageOptions, RowsPerPage } from '../../../table-helpers/table-helper';

@Injectable({
  providedIn: 'root',
})
export class PlannedMaintenanceFailureTableConfigService {
  public attributesConfig: TableConfig;

  private readonly rowNumber: string = 'rowIndex';
  constructor(private i18NextPipe: I18NextPipe) {}

  public initAttributesTableConfig(): void {
    const config = this.createBaseAttributeTableConfig();
    config.id = 'planned-maintenance-failure-table';
    config.title = this.i18NextPipe.transform('PlannedMaintenanceFailureModeSelectionDialog.SelectFailureMode');
    config.startingSortField = this.rowNumber;
    config.columns = this.createAttributeTableColumns();
    this.attributesConfig = config;
  }

  private createBaseAttributeTableConfig(): TableConfig {
    const config = new TableConfig();
    config.enableAdd = false;
    config.enableEdit = false;
    config.selectionMode = TableSelectionMode.Multiple;
    config.enableDelete = false;
    config.enableFiltering = false;
    config.enablePagination = true;
    config.lazyLoading = false;
    config.enableSorting = true;
    config.showRowHighlightInfoColumn = false;
    config.rowsPerPage = RowsPerPage.Medium;
    config.rowsPerPageOptions = defaultRowsPerPageOptions;
    config.dataKey = 'code';
    return config;
  }

  private createAttributeTableColumns(): TableColumn[] {
    const codeCol = new TableColumn(this.i18NextPipe.transform('PlannedMaintenanceFailureModeSelectionDialog.Code'), 'code');
    const nameCol = new TableColumn(this.i18NextPipe.transform('PlannedMaintenanceFailureModeSelectionDialog.FailureMode'), 'name');

    return [codeCol, nameCol];
  }
}
